import { useState } from "react";
import { toast } from "sonner";
import { api, fmtErr } from "../api";
import { useAuth } from "../AuthContext";

const inputCls = "w-full rounded-xl border border-slate-300 px-4 py-3 text-[15px] focus:outline-none focus:ring-2 focus:ring-brand-teal/60 focus:border-brand-teal";

export default function Settings() {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) {
      toast.error("New password must be at least 8 characters.");
      return;
    }
    if (next !== confirm) {
      toast.error("New passwords do not match.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated successfully.");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      toast.error(fmtErr(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-settings" className="max-w-2xl">
      <h1 className="font-display text-3xl md:text-4xl text-brand-navy">Settings</h1>
      <p className="mt-2 text-[15px] text-slate-600">Your office admin account details and security.</p>

      <section className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 md:p-8">
        <h2 className="font-display text-xl text-brand-navy">Account</h2>
        <div className="mt-4 space-y-3 text-[15px]">
          <p><span className="font-bold text-brand-navy">Name:</span> <span className="text-slate-600">{user?.name}</span></p>
          <p><span className="font-bold text-brand-navy">Email:</span> <span className="text-slate-600">{user?.email}</span></p>
          <p><span className="font-bold text-brand-navy">Role:</span> <span className="text-slate-600">Office Administrator</span></p>
        </div>
      </section>

      <section className="mt-6 rounded-2xl border border-slate-200 bg-white p-6 md:p-8">
        <h2 className="font-display text-xl text-brand-navy">Change Password</h2>
        <form onSubmit={submit} className="mt-5 space-y-4">
          <div>
            <label htmlFor="current-password" className="block text-sm font-bold text-brand-navy">Current Password</label>
            <input id="current-password" data-testid="current-password" type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} className={`mt-2 ${inputCls}`} />
          </div>
          <div>
            <label htmlFor="new-password" className="block text-sm font-bold text-brand-navy">New Password</label>
            <input id="new-password" data-testid="new-password" type="password" required value={next} onChange={(e) => setNext(e.target.value)} className={`mt-2 ${inputCls}`} />
          </div>
          <div>
            <label htmlFor="confirm-password" className="block text-sm font-bold text-brand-navy">Confirm New Password</label>
            <input id="confirm-password" data-testid="confirm-password" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className={`mt-2 ${inputCls}`} />
          </div>
          <button type="submit" data-testid="change-password-submit" disabled={saving} className="rounded-full bg-brand-teal px-6 py-3 text-[15px] font-bold text-white hover:bg-brand-navy transition-colors duration-300 active:scale-95 disabled:opacity-60">
            {saving ? "Updating…" : "Update Password"}
          </button>
        </form>
      </section>
    </div>
  );
}
